import * as mockResponses from './mockResponses';
import { FetchError } from '../models';

const mockFetch = async (uri: string, method: string) => {
    // delayed response
    await new Promise((resolve) => setTimeout(resolve, Math.floor(Math.random() * 500 + 500)));

    const response = uri
        .split('?')[0]
        .split('/')
        .reduce((acc, path) => acc[path], mockResponses)[method];

    if (!response) {
        console.log(`Mock response for ${method} ${uri} does not exist`);
        throw new FetchError('Mock Error', 418);
    }

    console.info('Mock request:', uri);

    return new Promise((resolve, reject) => {
        if (response.error) {
            if (response.error.code === 403) {
                const body = new Promise((res) => {
                    res(response.error.body);
                });
                reject(new FetchError('Mock Error', response.error.code, body));
                return;
            }

            reject(new FetchError('Mock Error', response.error.code));
            return;
        }
        console.info('Mock response:', response);
        resolve(response);
    });
};

export default mockFetch;
